import React from 'react';
import {H1, H2, H3, H4, H5, H6} from './Heading.styles';

interface Properties {
    children?: React.ReactNode;
    className?: string;
    level?: 1 | 2 | 3 | 4 | 5 | 6;
}
export const Heading = ({children, className, level = 3}: Properties): JSX.Element => {
    let heading: JSX.Element | undefined;
    switch (level) {
        case 1:
            heading = <H1 className={className}>{children}</H1>;
            break;
        case 2:
            heading = <H2 className={className}>{children}</H2>;
            break;
        case 3:
            heading = <H3 className={className}>{children}</H3>;
            break;
        case 4:
            heading = <H4 className={className}>{children}</H4>;
            break;
        case 5:
            heading = <H5 className={className}>{children}</H5>;
            break;
        case 6:
            heading = <H6 className={className}>{children}</H6>;
            break;
        default:
            heading = <H3 className={className}>{children}</H3>;
    }

    return heading;
};

export {H1, H2, H3, H4, H5, H6};
